import { Component, OnInit, Input } from '@angular/core';
import { LunaGisLayersService } from '../../../../../../../../../gis/services/luna-gis-layers.service';
import { ObjectProperties } from '../../../../../../../../../common/components/data-table/models/column.interface';
import { Subscription } from 'rxjs';

@Component({
    selector: 'layer-manager',
    templateUrl: './layer-manager.component.html',
    styleUrls: ['./layer-manager.component.scss'],
    providers: [LunaGisLayersService],
    standalone: false
})
export class LayerManagerComponent {
    @Input()
    config:any;
    serviceMappings: ObjectProperties[] = [];
    catalog: Catalog;
    public _subscription: Subscription = new Subscription();

    get services() {
        return this.catalog.featureSet.features;
    }

    constructor(
        public _lunaLayersService: LunaGisLayersService
    ) {
        this._subscription.add(this._lunaLayersService.getPortalCatalog().subscribe(
            (r) => {
                this.catalog = r;
                this.catalog.featureSet.features.forEach(x => {
                    x.attributes.title += ` ${x.attributes.type}`;
                });
                this.serviceMappings = this.createMappings(this.catalog.featureSet).content;
            }));
    }

    ngOnDestroy() {
        this._subscription.unsubscribe();
    }

    addLayer() {
        if (!this.config.layers)
            this.config.layers = [];

        this.config.layers.push({
               title: `Layer #${this.config.layers.length+1}`
        });
    }

    removeLayer(layer: any) {
        let idx = this.config.layers.findIndex(x => x === layer);

        if (idx != -1)
            this.config.layers.splice(idx, 1);
    }

    createMappings(featureSet: FeatureSet): ObjectProperties {
        let root = { path: '$', content: [] } as ObjectProperties;
        featureSet.features.forEach((x, idx) => {
            let node = {
                name: x.attributes.title,
                path: `$.${idx}`,
                content: [],
                data: x
            } as ObjectProperties;

            root.content.push(node);
        });

        return root;
    }
}

interface Catalog {
    featureSet: FeatureSet,
    layerDefinition: object,
    popupInfo: object;
}

interface FeatureSet {
    features: Feature[];
}

export interface Feature {
    attributes: {
        arcgisJslink: string,
        id: number,
        link: string,
        summary: string,
        thumbnail: string,
        title: string,
        type: string,
        ymax: number,
        ymin: number,
        xmax: number,
        xmin: number
    };
    geometry: { x: number, y: number };
}